import { errorUnservedMappings } from '../constants/error-unserved-mappings'

const unservedFields = (self) => [
  {
    label: self.$t('routeOptimization.fields.deliveryNumber'),
    key: 'number',
    isSortable: true,
    thAttr: {
      style: 'min-width:150px;max-width:150px;',
    },
  },
  {
    label: self.$t('routeOptimization.fields.status'),
    key: 'status.name',
  },
  {
    label: self.$t('routeOptimization.fields.originAddress'),
    key: 'origin_address.name',
    isSortable: true,
  },
  {
    label: self.$t('routeOptimization.fields.destinationAddress'),
    key: 'destination_address.name',
    isSortable: true,
  },
  {
    label: self.$t('routeOptimization.fields.createdOn'),
    key: 'created_on',
    isSortable: true,
  },
  {
    label: self.$t('routeOptimization.fields.createdBy'),
    key: 'created_by',
    isSortable: true,
  },
  {
    label: self.$t('routeOptimization.fields.shippedCustomerName'),
    key: 'shipped_customer.name',
    isSortable: true,
  },
  {
    label: self.$t('routeOptimization.fields.billedCustomerName'),
    key: 'billed_customer.name',
    isSortable: true,
  },
  {
    label: self.$t('routeOptimization.fields.marketingStaff'),
    key: 'marketing_user.name',
    isSortable: true,
  },
  {
    label: self.$t('routeOptimization.fields.productCategory'),
    key: 'product_categories',
    isSortable: false,
  },
  {
    label: self.$t('routeOptimization.fields.loadWeight'),
    key: 'load_weight',
    isSortable: true,
    formatter: (value) => (value !== null ? `${value} Kg` : null),
  },
  {
    label: self.$t('routeOptimization.fields.loadVolume'),
    key: 'load_volume',
    isSortable: true,
    formatter: (value) => (value !== null ? `${value} Cbm` : null),
  },
  {
    label: self.$t('routeOptimization.fields.reason'),
    key: 'unserved_reason.raw_type',
    isSticky: true,
    tdAttr: {
      style: 'right:0;position:sticky;border-left:1px solid #e6e7ec;min-width:150px;',
    },
    thAttr: {
      style: 'right:0;position:sticky;z-index:1;border-left:1px solid #e6e7ec;min-width:150px;',
    },
    formatter: (value) => self.$t(errorUnservedMappings[value]),
  },
]

export default unservedFields
